var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"column\" flex=\"100\"><div class=\"jumbotron\"><img" + (jade.attr("src", require("../../assets/banquetNinja2.png"), true, false)) + " class=\"img-responsive\"/><h2>This app has been retired</h2><p>banquet.ninja has been replaced by Restaurant Ninja. Please sign in there to manage your events and contracts.</p></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/home/home.jade
// module id = 163
// module chunks = 0